import React from 'react';
import {AppBar, Box, IconButton, Stack, Toolbar, Typography, useTheme} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import Login from './Login';
import {pageUrl, useAppNavigation} from './AppPages';
import MenuIcon from "@mui/icons-material/Menu";
import {useUiState} from "./uiStore";
import {OfficeIcon} from "../components/office-icon/OfficeIcon";
import {useCurrentOfficeStore} from "../api/CurrentOfficeStore";
import {RefreshIndicator} from "../components/refresh-indicator/RefreshIndicator";
import {GoToButton} from "../components/go-to-popup/GoToButton";

export default function AppHeader() {
    const theme = useTheme();
    const appNavigation = useAppNavigation();
    const {sidebarOpen: isOpen, openSidebar, sidebarWidth} = useUiState();
    const {officeId, officePathElement} = useCurrentOfficeStore();

    return (
        <AppBar
            position="sticky"
            sx={isOpen ? {
                width: `calc(100% - ${sidebarWidth}px)`,
                marginLeft: `${sidebarWidth}px`,
                transition: theme.transitions.create(['margin', 'width'], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            } : {
                transition: theme.transitions.create(['margin', 'width'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            }}
        >
            <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={openSidebar}
                    edge="start"
                    sx={[
                        {mr: 2},
                        isOpen && {display: 'none'},
                    ]}
                >
                    <MenuIcon/>
                </IconButton>
                <Typography variant="h6"
                            sx={{flexGrow: 1, textDecoration: 'none', color: 'inherit'}}
                            {...officePathElement ? {
                                component: RouterLink,
                                to: pageUrl(officePathElement, appNavigation.siteLogo)
                            } : {
                                component: "div"
                            }}
                >
                    <Stack direction="row" gap={2} alignItems="center" component="span">
                        {!isOpen && officeId != null && (
                            <OfficeIcon officeId={officeId}/>
                        )}
                        JetBrains Office
                    </Stack>
                </Typography>
                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <RefreshIndicator/>
                    <GoToButton/>
                    <Login/>
                </Box>
            </Toolbar>
        </AppBar>
    );
}